<!-- negative margin to offset the included padding for the modal -->
<section class="mb-[-1.75rem]">
	@if (analysis(); as analysis) {
		<mar-share-algolia-users-list
			[analysis]="analysis"
			placeholder="analyses.dialog.share-analysis.all-users.placeholder"
		/>
	} @else {
		<div class="w-full pt-16 pb-24 flex items-center justify-center">
			<tui-loader class="w-full h-full" size="l" />
		</div>
	}
</section>
